const HOME = {
  SET_PROP: 'SET_PROP',
  RESET_PROP: 'RESET_PROP',
};

export default HOME;